import classNames from 'classnames';
import { ILimitItem, IAnswerItem } from '@/utils/ctype';
import i18n from '@/locales/init'; 
import QuestionIndicator from '../QuestionIndicator';
import Arrow from '../Arrow';
import style from './index.module.less';

interface propsType {
  limits: ILimitItem[];
  answerAll: Array<IAnswerItem| null| undefined>;
  currentFocus: number;
  setPanelHandle: (val: number) => void;
  setFocusIndexHandle:(val: number) => void; 
  pageDataIndex: number;
  showNotePanel?: boolean;
}

export default function Bottom(props: propsType) {
  const {limits, answerAll, currentFocus, setPanelHandle, pageDataIndex, setFocusIndexHandle, showNotePanel = false} = props;
  return (
    <div className={classNames(style.bottomBox, showNotePanel && style.withNotePanel)}>
      <div className={style.questionNavigation }>
        {
          limits.map((item, index: number) => {
            return <QuestionIndicator {...item} answerAll={answerAll} currentFocus={currentFocus} key={index} setPanelHandle={setPanelHandle} index={index} pageDataIndex={pageDataIndex} isActive={pageDataIndex === index} setFocusIndexHandle={setFocusIndexHandle}></QuestionIndicator>;
          })
        }
        <Arrow limits={limits} setPanelHandle={setPanelHandle} setFocusIndexHandle={setFocusIndexHandle} currentFocus={currentFocus} pageDataIndex={pageDataIndex}></Arrow>
      </div>
      <div className={style.footer}>
        <span className={style.footerItem}>{i18n.t('common.dauyan_website_recorde_code')}</span>
        <span className={style.footerItem}>{i18n.t('common.dauyan_shenzhendauyan', { year: new Date().getFullYear() })}</span>
        <span className={style.footerItem}>{i18n.t('common.dauyan_phone')}</span>
      </div>
    </div>
  );
}
